// extracted by mini-css-extract-plugin
export var Address = "index-module--Address--20035";
export var ChangeLink = "index-module--ChangeLink--002cc";
export var Header = "index-module--Header--c96ae";
export var RTL = "index-module--RTL--c19ab";
export var ServiceOptionBox = "index-module--ServiceOptionBox--7a0fc";
export var ServingOption = "index-module--ServingOption--d88fd";